// 作文範例測驗數據
export const essayQuizzes = [
  // 記敘文測驗
  {
    id: 'narrative-school-trip-quiz',
    essayId: 'narrative-school-trip',
    title: '難忘的學校旅行 - 測驗',
    category: '記敘文',
    description: '測試對記敘文寫作技巧和內容理解',
    difficulty: 'intermediate',
    totalQuestions: 10,
    timeLimit: 600, // 10 minutes in seconds
    questions: [
      {
        id: 1,
        question: '這篇記敘文的主要寫作順序是什麼？',
        type: 'multiple-choice',
        options: [
          '空間順序',
          '時間順序',
          '邏輯順序',
          '重要性順序'
        ],
        correct: 1,
        explanation: '記敘文通常按時間順序來組織內容，從早上出發到晚上篝火晚會。',
        points: 10
      },
      {
        id: 2,
        question: '文中「那座巨大的銅佛莊嚴肅穆，令人肅然起敬」使用了什麼修辭手法？',
        type: 'multiple-choice',
        options: [
          '比喻',
          '擬人',
          '排比',
          '描寫'
        ],
        correct: 3,
        explanation: '這句話運用了描寫手法，通過形容詞「巨大」、「莊嚴肅穆」來描繪銅佛的外觀和給人的感受。',
        points: 10
      },
      {
        id: 3,
        question: '作者在文中重點描寫了哪些活動？',
        type: 'multiple-choice',
        options: [
          '參觀天壇大佛、乘坐纜車、海灘活動',
          '集合點名、坐巴士、吃午餐',
          '拍照留念、購買紀念品、休息',
          '聽導遊講解、做筆記、寫日記'
        ],
        correct: 0,
        explanation: '文中詳細描寫了參觀天壇大佛、乘坐纜車到昂坪村、海灘活動和篝火晚會等主要活動。',
        points: 10
      },
      {
        id: 4,
        question: '「車廂裡充滿了歡聲笑語」這句話的作用是什麼？',
        type: 'multiple-choice',
        options: [
          '描寫環境',
          '烘托氣氛',
          '推進情節',
          '點明主題'
        ],
        correct: 1,
        explanation: '這句話通過描寫車廂裡的歡聲笑語來烘托同學們興奮愉快的氣氛。',
        points: 10
      },
      {
        id: 5,
        question: '文章結尾的作用是什麼？',
        type: 'multiple-choice',
        options: [
          '總結全文',
          '點明主題',
          '抒發感情',
          '以上都是'
        ],
        correct: 3,
        explanation: '文章結尾既總結了全文，又點明了旅行的意義（增進友誼），同時抒發了珍藏美好回憶的感情。',
        points: 10
      },
      {
        id: 6,
        question: '「從高空俯瞰整個島嶼，景色美不勝收」中的「俯瞰」是什麼意思？',
        type: 'multiple-choice',
        options: [
          '平視觀看',
          '仰視觀看',
          '從高處向下看',
          '近距離觀看'
        ],
        correct: 2,
        explanation: '「俯瞰」指從高處向下看，符合乘坐纜車從高空觀看的情境。',
        points: 10
      },
      {
        id: 7,
        question: '這篇記敘文的敘述人稱是什麼？',
        type: 'multiple-choice',
        options: [
          '第一人稱',
          '第二人稱',
          '第三人稱',
          '混合人稱'
        ],
        correct: 0,
        explanation: '文章使用第一人稱「我」、「我們」來敘述，讓讀者有身臨其境的感受。',
        points: 10
      },
      {
        id: 8,
        question: '文中哪個細節最能體現師生關係的和諧？',
        type: 'multiple-choice',
        options: [
          '老師點名後出發',
          '老師和學生一起玩遊戲',
          '老師組織參觀活動',
          '老師維持秩序'
        ],
        correct: 1,
        explanation: '「老師也加入其中，和我們一起玩遊戲」最能體現師生之間親密和諧的關係。',
        points: 10
      },
      {
        id: 9,
        question: '「那一刻，師生之間的距離似乎拉近了許多」這句話表達了什麼？',
        type: 'multiple-choice',
        options: [
          '物理距離的接近',
          '心理距離的拉近',
          '時間的縮短',
          '空間的變化'
        ],
        correct: 1,
        explanation: '這句話表達的是心理距離的拉近，師生關係變得更加親密。',
        points: 10
      },
      {
        id: 10,
        question: '這篇記敘文的主題是什麼？',
        type: 'multiple-choice',
        options: [
          '描寫大嶼山的美麗風景',
          '記錄學校旅行的活動安排',
          '表達對美好回憶的珍藏和友誼的珍視',
          '介紹香港的旅遊景點'
        ],
        correct: 2,
        explanation: '文章通過記敘學校旅行，表達了對美好回憶的珍藏和對同學友誼的珍視。',
        points: 10
      }
    ]
  },

  // 描寫文測驗
  {
    id: 'descriptive-spring-garden-quiz',
    essayId: 'descriptive-spring-garden',
    title: '春天的花園 - 測驗',
    category: '描寫文',
    description: '測試對描寫文寫作技巧和修辭手法的理解',
    difficulty: 'intermediate',
    totalQuestions: 8,
    timeLimit: 480, // 8 minutes in seconds
    questions: [
      {
        id: 1,
        question: '描寫文的主要特點是什麼？',
        type: 'multiple-choice',
        options: [
          '敘述事件經過',
          '表達個人觀點',
          '描繪事物特徵',
          '說明道理'
        ],
        correct: 2,
        explanation: '描寫文的主要特點是通過生動的語言描繪事物的特徵和狀態。',
        points: 12
      },
      {
        id: 2,
        question: '「花朵們爭奇鬥艷」使用了什麼修辭手法？',
        type: 'multiple-choice',
        options: [
          '比喻',
          '擬人',
          '排比',
          '對比'
        ],
        correct: 1,
        explanation: '「爭奇鬥艷」把花朵當作人來寫，使用了擬人的修辭手法。',
        points: 12
      },
      {
        id: 3,
        question: '描寫文常用的觀察順序有哪些？',
        type: 'multiple-choice',
        options: [
          '時間順序、空間順序、邏輯順序',
          '重要性順序、因果順序、對比順序',
          '遠近順序、上下順序、左右順序',
          '以上都是'
        ],
        correct: 3,
        explanation: '描寫文可以按照不同的順序來組織內容，包括時間、空間、邏輯、遠近、上下、左右等順序。',
        points: 12
      },
      {
        id: 4,
        question: '「微風輕撫過花瓣」中的「輕撫」體現了什麼？',
        type: 'multiple-choice',
        options: [
          '動作的輕柔',
          '聲音的輕微',
          '顏色的淡雅',
          '氣味的清香'
        ],
        correct: 0,
        explanation: '「輕撫」是觸覺描寫，體現了微風動作的輕柔。',
        points: 12
      },
      {
        id: 5,
        question: '描寫文中運用五感描寫的目的是什麼？',
        type: 'multiple-choice',
        options: [
          '增加文章篇幅',
          '讓描寫更加生動具體',
          '顯示作者的文采',
          '符合寫作要求'
        ],
        correct: 1,
        explanation: '運用視覺、聽覺、嗅覺、味覺、觸覺等五感描寫，能讓描寫更加生動具體。',
        points: 12
      },
      {
        id: 6,
        question: '「蝴蝶在花叢中翩翩起舞」運用了什麼手法？',
        type: 'multiple-choice',
        options: [
          '比喻和擬人',
          '排比和對偶',
          '誇張和對比',
          '設問和反問'
        ],
        correct: 0,
        explanation: '「翩翩起舞」把蝴蝶飛舞比作人的舞蹈，運用了比喻和擬人的手法。',
        points: 12
      },
      {
        id: 7,
        question: '描寫文的語言特色是什麼？',
        type: 'multiple-choice',
        options: [
          '簡潔明瞭',
          '生動形象',
          '邏輯嚴密',
          '感情強烈'
        ],
        correct: 1,
        explanation: '描寫文的語言特色是生動形象，能夠讓讀者如見其形、如聞其聲。',
        points: 12
      },
      {
        id: 8,
        question: '好的描寫文應該達到什麼效果？',
        type: 'multiple-choice',
        options: [
          '讓讀者明白道理',
          '讓讀者產生共鳴',
          '讓讀者身臨其境',
          '讓讀者學到知識'
        ],
        correct: 2,
        explanation: '好的描寫文應該讓讀者通過文字描述產生身臨其境的感受。',
        points: 12
      }
    ]
  },

  // 說明文測驗
  {
    id: 'expository-environmental-protection-quiz',
    essayId: 'expository-environmental-protection',
    title: '環境保護的重要性 - 測驗',
    category: '說明文',
    description: '測試對說明文寫作結構和說明方法的理解',
    difficulty: 'intermediate',
    totalQuestions: 8,
    timeLimit: 480, // 8 minutes in seconds
    questions: [
      {
        id: 1,
        question: '說明文的主要目的是什麼？',
        type: 'multiple-choice',
        options: [
          '敘述事件',
          '抒發感情',
          '說明事理',
          '議論觀點'
        ],
        correct: 2,
        explanation: '說明文的主要目的是客觀地說明事物的特徵、性質或闡釋事理。',
        points: 12
      },
      {
        id: 2,
        question: '「舉例說明」屬於哪種說明方法？',
        type: 'multiple-choice',
        options: [
          '定義說明',
          '舉例說明',
          '比較說明',
          '分類說明'
        ],
        correct: 1,
        explanation: '舉例說明是通過具體的例子來說明抽象的概念或道理。',
        points: 12
      },
      {
        id: 3,
        question: '說明文的語言特點是什麼？',
        type: 'multiple-choice',
        options: [
          '生動活潑',
          '準確嚴謹',
          '感情豐富',
          '想象豐富'
        ],
        correct: 1,
        explanation: '說明文的語言特點是準確嚴謹，用詞精確，邏輯清晰。',
        points: 12
      },
      {
        id: 4,
        question: '「數據統計」在說明文中的作用是什麼？',
        type: 'multiple-choice',
        options: [
          '增加文章篇幅',
          '提供具體證據',
          '顯示作者博學',
          '美化文章語言'
        ],
        correct: 1,
        explanation: '數據統計能夠提供具體的證據，使說明更加客觀可信。',
        points: 12
      },
      {
        id: 5,
        question: '說明文的結構通常是什麼？',
        type: 'multiple-choice',
        options: [
          '總-分-總',
          '起-承-轉-合',
          '開頭-主體-結尾',
          '以上都可以'
        ],
        correct: 3,
        explanation: '說明文可以採用多種結構方式，如總-分-總、並列式、遞進式等。',
        points: 12
      },
      {
        id: 6,
        question: '「環境污染日益嚴重」中的「日益」表示什麼？',
        type: 'multiple-choice',
        options: [
          '每天都有',
          '逐漸增加',
          '突然出現',
          '偶爾發生'
        ],
        correct: 1,
        explanation: '「日益」表示程度逐漸增加，強調環境污染問題的嚴重性在不斷加劇。',
        points: 12
      },
      {
        id: 7,
        question: '說明文中使用「比較說明」的好處是什麼？',
        type: 'multiple-choice',
        options: [
          '使文章更生動',
          '突出事物特點',
          '增加文章趣味',
          '表達個人觀點'
        ],
        correct: 1,
        explanation: '比較說明通過對比來突出事物的特點，使讀者更容易理解。',
        points: 12
      },
      {
        id: 8,
        question: '好的說明文應該具備什麼特點？',
        type: 'multiple-choice',
        options: [
          '內容豐富、語言華麗',
          '條理清晰、用詞準確',
          '感情真摯、想象豐富',
          '觀點鮮明、論證有力'
        ],
        correct: 1,
        explanation: '好的說明文應該條理清晰、用詞準確，能夠客觀地說明事物。',
        points: 12
      }
    ]
  },

  // 議論文測驗
  {
    id: 'argumentative-reading-benefits-quiz',
    essayId: 'argumentative-reading-benefits',
    title: '讀書的好處 - 測驗',
    category: '議論文',
    description: '測試對議論文三要素和論證方法的理解',
    difficulty: 'advanced',
    totalQuestions: 10,
    timeLimit: 600, // 10 minutes in seconds
    questions: [
      {
        id: 1,
        question: '議論文的三要素是什麼？',
        type: 'multiple-choice',
        options: [
          '論點、論據、論證',
          '開頭、主體、結尾',
          '觀點、材料、結論',
          '主題、內容、形式'
        ],
        correct: 0,
        explanation: '議論文的三要素是論點（作者的觀點）、論據（支持觀點的材料）、論證（論述的過程）。',
        points: 10
      },
      {
        id: 2,
        question: '「事實論據」和「道理論據」的區別是什麼？',
        type: 'multiple-choice',
        options: [
          '事實論據是具體的，道理論據是抽象的',
          '事實論據是古代的，道理論據是現代的',
          '事實論據是中國的，道理論據是外國的',
          '沒有區別'
        ],
        correct: 0,
        explanation: '事實論據是具體的事例、數據等，道理論據是抽象的原理、名言等。',
        points: 10
      },
      {
        id: 3,
        question: '「讀書破萬卷，下筆如有神」是什麼論據？',
        type: 'multiple-choice',
        options: [
          '事實論據',
          '道理論據',
          '比喻論據',
          '對比論據'
        ],
        correct: 1,
        explanation: '這是杜甫的名句，屬於道理論據，用來支持讀書的重要性。',
        points: 10
      },
      {
        id: 4,
        question: '議論文的論證方法不包括以下哪種？',
        type: 'multiple-choice',
        options: [
          '舉例論證',
          '道理論證',
          '對比論證',
          '描寫論證'
        ],
        correct: 3,
        explanation: '議論文的論證方法包括舉例論證、道理論證、對比論證、比喻論證等，但不包括描寫論證。',
        points: 10
      },
      {
        id: 5,
        question: '「讀書不僅能增長知識，還能陶冶情操」這句話的論證結構是什麼？',
        type: 'multiple-choice',
        options: [
          '並列關係',
          '遞進關係',
          '因果關係',
          '轉折關係'
        ],
        correct: 1,
        explanation: '「不僅...還能...」表示遞進關係，後面的內容比前面的更進一步。',
        points: 10
      },
      {
        id: 6,
        question: '議論文的開頭通常要做什麼？',
        type: 'multiple-choice',
        options: [
          '描寫環境',
          '敘述事件',
          '提出論點',
          '抒發感情'
        ],
        correct: 2,
        explanation: '議論文的開頭通常要提出中心論點，明確文章要論述的觀點。',
        points: 10
      },
      {
        id: 7,
        question: '「反面論證」的作用是什麼？',
        type: 'multiple-choice',
        options: [
          '增加文章篇幅',
          '從反面證明論點',
          '批評對手觀點',
          '顯示作者博學'
        ],
        correct: 1,
        explanation: '反面論證通過反面的例子或道理來證明正面論點的正確性。',
        points: 10
      },
      {
        id: 8,
        question: '議論文的語言特點是什麼？',
        type: 'multiple-choice',
        options: [
          '生動形象',
          '準確嚴密',
          '感情豐富',
          '想象豐富'
        ],
        correct: 1,
        explanation: '議論文的語言特點是準確嚴密，用詞精確，邏輯性強。',
        points: 10
      },
      {
        id: 9,
        question: '「總而言之」、「綜上所述」等詞語通常出現在文章的哪個部分？',
        type: 'multiple-choice',
        options: [
          '開頭',
          '主體',
          '結尾',
          '任何地方'
        ],
        correct: 2,
        explanation: '「總而言之」、「綜上所述」等總結性詞語通常出現在文章結尾。',
        points: 10
      },
      {
        id: 10,
        question: '好的議論文應該具備什麼特點？',
        type: 'multiple-choice',
        options: [
          '論點明確、論據充分、論證有力',
          '文字華麗、內容豐富、篇幅很長',
          '感情真摯、想象豐富、語言生動',
          '敘述詳細、描寫生動、結構完整'
        ],
        correct: 0,
        explanation: '好的議論文應該論點明確、論據充分、論證有力，具有說服力。',
        points: 10
      }
    ]
  },

  // 應用文測驗
  {
    id: 'practical-sports-day-notice-quiz',
    essayId: 'practical-sports-day-notice',
    title: '運動會通知 - 測驗',
    category: '應用文',
    description: '測試對應用文格式和寫作要求的理解',
    difficulty: 'beginner',
    totalQuestions: 6,
    timeLimit: 360, // 6 minutes in seconds
    questions: [
      {
        id: 1,
        question: '應用文的主要特點是什麼？',
        type: 'multiple-choice',
        options: [
          '文學性強',
          '實用性強',
          '藝術性強',
          '趣味性強'
        ],
        correct: 1,
        explanation: '應用文的主要特點是實用性強，用於處理具體的事務。',
        points: 16
      },
      {
        id: 2,
        question: '通知的格式包括哪些要素？',
        type: 'multiple-choice',
        options: [
          '標題、正文、落款',
          '標題、正文、日期',
          '標題、正文、落款、日期',
          '正文、落款、日期'
        ],
        correct: 2,
        explanation: '通知的格式包括標題、正文、落款（發文單位）、日期四個要素。',
        points: 16
      },
      {
        id: 3,
        question: '通知的語言特點是什麼？',
        type: 'multiple-choice',
        options: [
          '生動活潑',
          '簡潔明瞭',
          '感情豐富',
          '想象豐富'
        ],
        correct: 1,
        explanation: '通知的語言特點是簡潔明瞭，準確傳達信息。',
        points: 16
      },
      {
        id: 4,
        question: '「茲定於」在通知中的作用是什麼？',
        type: 'multiple-choice',
        options: [
          '表示時間',
          '表示地點',
          '表示決定',
          '表示原因'
        ],
        correct: 2,
        explanation: '「茲定於」是公文用語，表示決定在某個時間做某事。',
        points: 16
      },
      {
        id: 5,
        question: '通知的正文應該包含什麼內容？',
        type: 'multiple-choice',
        options: [
          '事件的時間、地點、內容',
          '個人的感受和看法',
          '詳細的背景介紹',
          '華麗的修辭語言'
        ],
        correct: 0,
        explanation: '通知的正文應該包含事件的時間、地點、內容等基本信息。',
        points: 16
      },
      {
        id: 6,
        question: '「特此通知」通常出現在通知的哪個位置？',
        type: 'multiple-choice',
        options: [
          '開頭',
          '中間',
          '結尾',
          '標題'
        ],
        correct: 2,
        explanation: '「特此通知」是結束語，通常出現在通知正文的結尾。',
        points: 16
      }
    ]
  }
];

// 測驗統計數據
export const quizStats = {
  totalQuizzes: essayQuizzes.length,
  totalQuestions: essayQuizzes.reduce((sum, quiz) => sum + quiz.totalQuestions, 0),
  averageTimePerQuiz: Math.round(essayQuizzes.reduce((sum, quiz) => sum + quiz.timeLimit, 0) / essayQuizzes.length / 60), // in minutes
  difficultyDistribution: {
    beginner: essayQuizzes.filter(quiz => quiz.difficulty === 'beginner').length,
    intermediate: essayQuizzes.filter(quiz => quiz.difficulty === 'intermediate').length,
    advanced: essayQuizzes.filter(quiz => quiz.difficulty === 'advanced').length
  },
  categoryDistribution: essayQuizzes.reduce((acc, quiz) => {
    acc[quiz.category] = (acc[quiz.category] || 0) + 1;
    return acc;
  }, {})
};

// 獲取特定作文的測驗
export const getQuizByEssayId = (essayId) => {
  return essayQuizzes.find(quiz => quiz.essayId === essayId);
};

// 獲取特定類別的測驗
export const getQuizzesByCategory = (category) => {
  return essayQuizzes.filter(quiz => quiz.category === category);
};

// 獲取特定難度的測驗
export const getQuizzesByDifficulty = (difficulty) => {
  return essayQuizzes.filter(quiz => quiz.difficulty === difficulty);
};

// 測驗結果評分標準
export const gradingScale = {
  excellent: { min: 90, max: 100, label: '優秀', color: 'text-green-600', bgColor: 'bg-green-100' },
  good: { min: 80, max: 89, label: '良好', color: 'text-blue-600', bgColor: 'bg-blue-100' },
  satisfactory: { min: 70, max: 79, label: '及格', color: 'text-yellow-600', bgColor: 'bg-yellow-100' },
  needsImprovement: { min: 0, max: 69, label: '需要改進', color: 'text-red-600', bgColor: 'bg-red-100' }
};

// 獲取成績等級
export const getGradeLevel = (score) => {
  for (const [key, grade] of Object.entries(gradingScale)) {
    if (score >= grade.min && score <= grade.max) {
      return { key, ...grade };
    }
  }
  return gradingScale.needsImprovement;
};

// 學習建議
export const getStudyRecommendations = (score, category) => {
  const gradeLevel = getGradeLevel(score);
  
  const recommendations = {
    excellent: [
      '恭喜！您對這類文體的掌握非常好。',
      '建議嘗試更高難度的練習題。',
      '可以幫助其他同學學習這類文體。'
    ],
    good: [
      '您的基礎很好，還有進步空間。',
      '建議多做一些類似的練習題。',
      '注意細節和寫作技巧的運用。'
    ],
    satisfactory: [
      '基本概念掌握得還可以。',
      '建議重新複習相關的寫作技巧。',
      '多閱讀這類文體的範例。'
    ],
    needsImprovement: [
      '需要加強對這類文體的理解。',
      '建議先複習基礎知識。',
      '可以請教老師或同學。'
    ]
  };
  
  return recommendations[gradeLevel.key] || recommendations.needsImprovement;
}; 